import { LegalLayout } from "./LegalLayout";

/**
 * Impressum gemäß § 5 TMG. Public route at /impressum — reachable from
 * the auth-layout footer (unauthed) and the settings sheet (authed) so the
 * "max 2 clicks from any page" requirement holds.
 *
 * Content kept short on purpose: every line maps to a specific TMG / MStV /
 * VSBG obligation. Don't add marketing text here; if scope grows put it on
 * a separate /about page.
 */
export function ImprintPage() {
  return (
    <LegalLayout title="Impressum" subtitle="Angaben gemäß § 5 TMG">
      <section>
        <address className="not-italic">
          <strong className="text-fg">Concept4IT Consulting GmbH</strong>
          <br />
          Gustav-Freytag-Straße 36
          <br />
          60320 Frankfurt am Main
          <br />
          Deutschland
        </address>
      </section>

      <section>
        <h2 className="text-base font-semibold text-fg mb-1">Kontakt</h2>
        <p>
          E-Mail:{" "}
          <span className="font-mono">contact[at]concept4it.com</span>
          <br />
          <span className="text-xs text-fg-faint">
            (Bitte „[at]" beim Senden durch „@" ersetzen — Spam-Schutz.)
          </span>
        </p>
      </section>

      <section>
        <h2 className="text-base font-semibold text-fg mb-1">
          Vertretungsberechtigter Geschäftsführer
        </h2>
        <p>Doron Marcu</p>
      </section>

      <section>
        <h2 className="text-base font-semibold text-fg mb-1">Handelsregister</h2>
        <p>
          Amtsgericht Frankfurt am Main
          <br />
          HRB 80871
        </p>
      </section>

      <section>
        <h2 className="text-base font-semibold text-fg mb-1">
          Umsatzsteuer-Identifikationsnummer
        </h2>
        <p>
          gem. § 27 a Umsatzsteuergesetz:
          <br />
          DE256618537
        </p>
      </section>

      <section>
        <h2 className="text-base font-semibold text-fg mb-1">
          Verantwortlich für den Inhalt
        </h2>
        <p>
          nach § 18 Abs. 2 MStV:
          <br />
          Doron Marcu (Anschrift wie oben)
        </p>
      </section>

      <section>
        <h2 className="text-base font-semibold text-fg mb-1">EU-Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
          bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent hover:underline break-all"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          . Unsere E-Mail-Adresse findest du oben im Impressum.
        </p>
      </section>

      <section>
        <h2 className="text-base font-semibold text-fg mb-1">Verbraucherstreitbeilegung</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>
    </LegalLayout>
  );
}
